import { Box, Text } from '@chakra-ui/react'
import type { ReactElement } from 'react'

import QuickLinks, { type QuickLink } from '@/components/QuickLinks'

export function CommonQuestions({ links }: { links: QuickLink[] }): ReactElement {
  return (
    <Box>
      <Text variant="eyebrow" mb="8px" pl="8px">
        Common Questions
      </Text>
      <QuickLinks links={links} hideHeading titleProps={{ fontWeight: 400 }} />
    </Box>
  )
}
